import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { gql } from '@/utilities/gql';
import { PRIMARY_MARKETS } from '@/constants/markets';

import type { CountryISO } from '@/constants/countries';

const QUERY = gql(`
  query getBrokerages($isGlobal: Boolean = false, $countryISO: String) {
    fetchBrokerages(
      input: {
        filter: {
          countryISO: $countryISO
          isGlobal: $isGlobal
          # minWeight: 0 // TODO: Uncomment once weights check is fixed
        }
        orderBy: [{ field: "weight", direction: "DESC" }]
        supportedProviders: ["plaid", "passiv", "sharesight"]
        limit: 6
      }
     ) {
      id
      slug
      name
      url
      provider {
        name
      }
      providerBrokerageId
      logoUrl
      countryISO
    }
  }
`);

export const usePopularBrokerage = (countryISO: CountryISO) => {
  const { data } = makeGqlSuspenseQuery(QUERY)({
    countryISO: countryISO.toUpperCase(),
  });

  const marketBrokerages = data.fetchBrokerages;

  const marketTitle: string =
    countryISO in PRIMARY_MARKETS && PRIMARY_MARKETS[countryISO]?.label;

  // Display global brokerages when no brokerages are found in the user's market
  if (!marketTitle || marketBrokerages.length === 0) {
    const { data } = makeGqlSuspenseQuery(QUERY)({
      isGlobal: true,
    });
    return {
      brokerages: data.fetchBrokerages,
      heading: 'Top brokers worldwide',
    };
  }

  return {
    brokerages: marketBrokerages,
    heading: `Top brokers in ${marketTitle}`,
  };
};
